import api from './api';

const healthService = {
  // Get health scores for all platforms
  getHealthScores: async () => {
    const response = await api.get('/api/v1/health/scores');
    return response.data.data;
  },

  // Get health alerts
  getAlerts: async () => {
    const response = await api.get('/api/v1/health/alerts');
    return response.data.data;
  },

  // Acknowledge an alert
  acknowledgeAlert: async (alertId) => {
    const response = await api.put(`/api/v1/health/alerts/${alertId}/acknowledge`);
    return response.data.data;
  },

  // Get health score for a specific connection (multi-account)
  getConnectionScore: async (connectionId) => {
    const response = await api.get(`/api/v1/health/scores/connection/${connectionId}`);
    return response.data.data;
  },

  // Get health score history, optionally filtered by connectionId
  getScoreHistory: async (params = {}) => {
    const response = await api.get('/api/v1/health/history', { params });
    return response.data.data;
  },

  // Get overall composite health score
  getOverallScore: async () => {
    const response = await api.get('/api/v1/health/score');
    return response.data.data;
  },

  // Get health recommendations
  getRecommendations: async () => {
    const response = await api.get('/api/v1/health/recommendations');
    return response.data.data;
  },

  // Trigger manual health check
  triggerCheck: async () => {
    const response = await api.post('/api/v1/health/check');
    return response.data;
  },
};

export default healthService;
